import type { OrgRedemptionRow } from '@/types/wire';

/** O04 "Export CSV": the fulfilled rows, one line each. Columns are the brief's; no child data beyond the first name. */
export const CSV_COLUMNS = ['code', 'child', 'reward', 'requestedAt', 'fulfilledAt'] as const;

export function csvCell(value: string | undefined): string {
  const v = value ?? '';
  return /[",\n\r]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v;
}

export function csvRows(rows: ReadonlyArray<OrgRedemptionRow>): string[][] {
  return rows.map((r) => [
    r.code,
    r.child.firstName,
    r.reward.title,
    r.requestedAt,
    r.fulfilledAt ?? '',
  ]);
}

export function toCsv(rows: ReadonlyArray<OrgRedemptionRow>): string {
  const lines = [[...CSV_COLUMNS], ...csvRows(rows)].map((line) => line.map(csvCell).join(','));
  return `${lines.join('\r\n')}\r\n`;
}

/** Hands the browser a Blob URL; the anchor is removed once clicked. */
export function downloadCsv(filename: string, csv: string): void {
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
